import { ValueError, splitEntity } from "shelving";
import { GroupRouter } from "../group/GroupRouter.js";
import { ProfileRouter } from "../profile/ProfileRouter.js";
import { useUsernameItem } from "../util/data.js";

/** Page that looks up a username in the `username` table and routes to either the profile router or clan router depending on the type of the username. */
export function UsernameRouter({ username, slug }: { username: string; slug?: string | undefined }): React.ReactElement {
	const { creator } = useUsernameItem(username).data;
	const [type, id] = splitEntity(creator);
	if (type === "profile") return <ProfileRouter uid={id} slug={slug} />;
	if (type === "group") return <GroupRouter gid={id} slug={slug} />;
	throw new ValueError("Invalid username type", type);
}
